/*
 * TORNA sticky add-to-cart (prompt 3.1)
 * Toont de sticky bestelbalk op mobiel zodra de hoofd add-to-cart uit beeld is.
 * Klik op de sticky knop triggert de echte add-to-cart knop in het productformulier.
 */
(function () {
  var sticky = document.querySelector('[data-torna-sticky]');
  if (!sticky) return;

  // Element dat we observeren: expliciete anchor, anders de echte add-knop.
  var anchor =
    document.querySelector('[data-torna-atc-anchor]') ||
    document.querySelector('product-form-component button[name="add"]') ||
    document.querySelector('form[action*="/cart/add"] button[name="add"]');

  var realAddButton =
    document.querySelector('product-form-component button[name="add"]') ||
    document.querySelector('form[action*="/cart/add"] button[name="add"]');

  if (!anchor || !realAddButton) return;

  // Sticky knop stuurt het echte formulier.
  var stickyButton = sticky.querySelector('[data-torna-sticky-order]');
  if (stickyButton) {
    stickyButton.addEventListener('click', function () {
      realAddButton.click();
    });
  }

  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        // Toon de balk wanneer de hoofd-ATC NIET zichtbaar is.
        if (entry.isIntersecting) {
          sticky.setAttribute('hidden', '');
        } else {
          sticky.removeAttribute('hidden');
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0 }
  );

  observer.observe(anchor);
})();
